/*--------------------------------------
 SORT BY
 --------------------------------------*/
sortBy = {
    init: function () {
        const $sort = $(".collection-sort");

        $(".collection-sort__toggle").off("click.collectionSort").on("click.collectionSort", function (event) {
            event.preventDefault();
            const $currentSort = $(this).closest(".collection-sort");
            const isOpen = $currentSort.hasClass("open");

            $(".collection-sort").removeClass("open");
            $(".collection-sort__toggle").attr("aria-expanded", "false");
            $(".collection-sort__panel").attr("aria-hidden", "true");

            if (!isOpen) {
                $currentSort.addClass("open");
                $(this).attr("aria-expanded", "true");
                $currentSort.find(".collection-sort__panel").attr("aria-hidden", "false");
            }
        });

        $("body").off("click.collectionSort").on("click.collectionSort", function (event) {
            if (!$(event.target).closest(".collection-sort").length) {
                $sort.removeClass("open");
                $(".collection-sort__toggle").attr("aria-expanded", "false");
                $(".collection-sort__panel").attr("aria-hidden", "true");
            }
        });
    }
};

$(document).ready(function () {
    sortBy.init();
});

$(document).on("shopify:section:load", function () {
    sortBy.init();
});
